<p-tieredMenu #tmenu
    *ngIf="!isMobile"
    [model]="items"
    [popup]="true">
</p-tieredMenu>

<p-slideMenu #smenu *ngIf="isMobile" 
        [model]="items"
        [popup]="true"
        [viewportHeight]="320">
</p-slideMenu>
